var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-list"},[_vm._l((_vm.data),function(item,index){return _c('file-item',{key:index,attrs:{"data":item,"action":_vm.action,"size":_vm.size,"btn-layout":_vm.btnLayout,"hideFileName":_vm.hideFileName},on:{"del":function($event){return _vm.$emit('del', {data: $event, index})}}})}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }